class ProductCardATCModal extends HTMLElement {
  constructor() {
    super();
    this.closeModalEvent = this.closeModal.bind(this);
    this.hitEscapeEvent = this.hitEscape.bind(this);
    this.clickOutsideEvent = this.clickOutside.bind(this);
  }

  get modalTrigger() {
    return document.querySelector(`[data-atc-modal-trigger="${this.id}"]`);
  }

  get buyButton() {
    return this.querySelector('button');
  }

  connectedCallback() {
    this.modalTrigger.addEventListener('click', this.openModal.bind(this));

    // emitted from skio plan picker component
    this.addEventListener('skio::update-price', ({ detail }) => {
      this.updateAtcPrice(detail.price);
    })
  }

  openModal(e) {
    this.classList.remove('hidden');
    window.addEventListener('keydown', this.hitEscapeEvent);
    window.addEventListener('click', this.clickOutsideEvent);
    this.buyButton.focus();
  }

  closeModal(e) {
    this.classList.add('hidden');
    window.removeEventListener('keydown', this.hitEscapeEvent);
    window.removeEventListener('click', this.clickOutsideEvent);
  }

  hitEscape(e) {
    if(e.key !== 'Escape') return;
    this.closeModal();
  }

  clickOutside(e) {
    let eventPath = e.composedPath();
    if(eventPath.includes(this) || eventPath.includes(this.modalTrigger)) return;
    this.closeModal();
  }

  updateAtcPrice(price) {
    this.buyButton.querySelector('[data-atc-modal-price]').textContent = ` - ${price}`;
  }
}

customElements.define('product-card-atc-modal', ProductCardATCModal);

// IIFE for filters and sorting behavior
(() => {
  document.querySelectorAll('[data-apply-filters]').forEach(button => {
    button.addEventListener('click', () => {
      const selectedFilters = Array.from(document.querySelectorAll('[name="filter"]:checked'))?.map(filter => filter.value),
            urlParams = location.search,
            urlNoFilters = document.querySelector('[data-reset-filters]').href;
      
      let newUrl = selectedFilters.reduce((acc, cur, idx) => {
        let ret = `${acc}${idx <= 0 ? '/' : ''}${cur}`;
        if(idx < selectedFilters.length - 1) ret += '+';
        return ret;
      }, urlNoFilters)
      location.href = newUrl + urlParams;
    });
  });

  document.querySelectorAll('[data-apply-filters-mobile]').forEach(button => {
    button.addEventListener('click', () => {
      const selectedFilters = Array.from(document.querySelectorAll('[name="filter-mobile"]:checked'))?.map(filter => filter.value),
            selectedSortOption = document.querySelector('[name="sort-option-mobile"]:checked')?.value,
            url = new URL(location.href),
            urlNoFilters = document.querySelector('[data-reset-filters]').href;
      
      let newUrl = selectedFilters.reduce((acc, cur, idx) => {
        let ret = `${acc}${idx <= 0 ? '/' : ''}${cur}`;
        if(idx < selectedFilters.length - 1) ret += '+';
        return ret;
      }, urlNoFilters)
      if(selectedSortOption) url.searchParams.set('sort_by', selectedSortOption);
      location.href = newUrl + '?' + url.searchParams;
    });
  });

  document.querySelectorAll('[data-collections-sort-by]').forEach(dropdown => {
    dropdown.addEventListener('change', e => {
      let url = new URL(location.href);
      url.searchParams.set('sort_by', e.target.value);
      location.href = url;
    });
  });

  document.querySelector('#collections-filtering-desktop')?.addEventListener('click', e => {
    const panelIds = e.currentTarget.getAttribute('aria-controls').split(' '),
          state = e.currentTarget.getAttribute('aria-expanded') === "true";

    e.currentTarget.setAttribute('aria-expanded', !state)
    panelIds.forEach(panelId => {
      let panel = document.querySelector(`#${panelId}`);
      panel.classList.toggle('hidden', state)
    });
  });

  document.querySelector('#collections-filtering-mobile')?.addEventListener('click', e => {
    const modal = document.querySelector('#collections-filtering-mobile-modal'),
          closeButton = document.querySelector('[data-close-filters-modal]');

    modal.classList.remove('hidden');
    closeButton.focus();
  });

  document.querySelectorAll('[data-close-filters-modal]').forEach(button => {
    button.addEventListener('click', () => {
      const modal = document.querySelector('#collections-filtering-mobile-modal'),
            modalTrigger = document.querySelector('#collections-filtering-mobile');
  
      modal.classList.add('hidden');
      modalTrigger.focus();
    });
  });

  document.addEventListener('keydown', e => {
    if(e.key !== 'Escape') return;
    const modal = document.querySelector('#collections-filtering-mobile-modal'),
          modalTrigger = document.querySelector('#collections-filtering-mobile');

    modal.classList.add('hidden');
    modalTrigger.focus();
  });
})();